import { Injectable } from '@angular/core';
import { State } from 'app/core/state';
import { DAT, DATRecords } from 'app/modules/daily-activity-tracker/model';
import { first } from 'lodash';

@Injectable({ providedIn: 'root' })
export class DATState extends State<DATRecords> implements DATRecords
{
    records: DAT[];

    constructor() {
        super();
    }

    key() {
        return "dat_records"
    }

    findById(id) {
        return first(this.records.filter((record) => record.id == id));
    }
}
